(function ($) {
    "use strict";
    $(function () {

        if ($(".template--best-song").length === 0) {
            return;
        }

        $('.song-select').SumoSelect({ search: true, searchText: 'Keresés.', noMatch: 'Nincs találat a következőre: "{0}"' });

        $('.js-song-select').on('change', function (e) {
            $('.js-song-submit').parent().removeClass('wrapper--disabled');
            $('.js-song-submit').removeAttr('disabled');
        });

        $.ajax({
            url: localize.ajaxurl,
            type: "POST",
            data: {
                action: "get_songs",
            },
            error: function (response) {
                console.log(response);
            },
            success: function (response) {
                const songs = JSON.parse(response);

                songs.forEach(song => {

                    $('.song-select')[0].sumo.add(song.id, song.title);

                })
            }
        });

        $('#vote-form').on('submit', function (e) {
            e.preventDefault();
            const theForm = $(this);
            const data = theForm.serializeArray()[0];
            $.ajax({
                url: localize.ajaxurl,
                type: "POST",
                data: {
                    action: "vote",
                    songid: data.value,
                    nonce: localize.nonce
                },
                error: function (response) {
                    console.log(response);
                },
                success: function (response) {
                    Cookies.set('bob', true);
                    var currentHeight = $('.js-form-wrapper').outerHeight();
                    $('.js-form-wrapper').css('height', currentHeight);
                    theForm.replaceWith(`<h1 class="title title--thank-you">Köszönjük <br>a szavazatodat!</h1>`)
                }
            });

            return false;
        });
    });
})(jQuery);